// src/shared/units.js — еднакви мерки, написани различно (ПРОМТ-13б).
//
// ОГЛЕДАЛНО КОПИЕ на таблицата в services/articles.js — екранът не може да
// внася сървърен модул. Смятането остава на сървъра; тук е само за да не
// предлага екранът „g" и „г" като две различни мерки. Двете таблици се
// сверяват от test/article-units.test.js — промяна само на едното място
// чупи теста.

export const UNIT_SYNONYMS = [
  ['бр', 'брой', 'броя', 'бройка', 'pcs'],
  ['кг', 'kg'],
  ['г', 'гр', 'g'],
  ['л', 'l'],
  ['мл', 'ml'],
];
export const METRIC = [
  ['г', 'кг', 0.001],
  ['мл', 'л', 0.001],
];

const CANON = new Map();
for (const r of UNIT_SYNONYMS) for (const u of r) CANON.set(u, r[0]);

export function unitKey(unit) {
  const s = String(unit == null ? '' : unit).toLowerCase().replace(/\s+/g, '').replace(/\.+$/, '');
  return CANON.get(s) || s;
}

// Мерките, в които може да се въведе количество за артикула: базовата,
// преобразуванията му и стандартната метрична (г към кг, мл към л) — без
// повторения под друго изписване.
export function unitsOf(article) {
  const out = [];
  const keys = new Set();
  const add = (u) => {
    const s = String(u == null ? '' : u).trim();
    if (!s || keys.has(unitKey(s))) return;
    keys.add(unitKey(s));
    out.push(s);
  };
  if (article) add(article.measure);
  ((article && article.conversions) || []).forEach((c) => add(c && c.unit));
  const base = unitKey(article && article.measure);
  for (const [small, big] of METRIC) {
    if (base === big) add(small);
    if (base === small) add(big);
  }
  return out;
}
